var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"xl":"8"}},[_c('api-keys'),_c('account-details')],1),_c('b-col',{attrs:{"xl":"4"}},[_c('plan')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }